import Vue from 'vue';
import {Prop} from 'vue/types/options';
import EventHub from '../../eventHub';
import MultiSelectGroup from './multiSelectGroup.html';
import EcCommon from '../../../../types/ec/ecCommon';

export default Vue.component('ecMultiSelectGroup', {
	template: MultiSelectGroup,
	props: {
		buttonLabel: String,
		choices: Array as Prop<EcCommon.IMultiSelctGroupChoices[]>,
		eventName: String,
		fieldSetLabel: String,
	},
	methods: {
		stateChanged(option: EcCommon.IMultiSelectGroupOptions): void {
			const name = this.eventName + '-optionStateChanged';
			EventHub.$emit(name, option);
        },
	 },
});
